module.exports = __webpack_public_path__ + "static/img/dwzm.7aba0088.png";